import React from "react"
import { useTranslation } from "react-i18next";

// MUI
import {Box, Typography, Divider} from "@mui/material"

// Custom
import GeoBaseLayerSwitcher from "@/components/Map/Controls/GEO/GeoBaseLayerSwticher";
import { BaseLayerSwitcherControl } from "@/components/Map/Controls";
import { PublicLayerTree } from "@/components/Map/Controls";

// OL
import { Collection } from "ol";
import OlBaseLayer from "ol/layer/Base";
import OlLayerGroup from "ol/layer/Group";
import BaseLayer from "ol/layer/Base";

function PublicOptionsPane( props: {mapId: number, apiLayersCollection: Collection<OlBaseLayer>, clientLayersCollection: Collection<OlBaseLayer>, baseLayers: BaseLayer[]}) {

    const { mapId, apiLayersCollection, clientLayersCollection, baseLayers }= props;
    const { t } = useTranslation();

    return (
        <Box position={"relative"} height={"100%"} width={"100%"} p={2}>
            <Box>
                <Typography variant="h6" component="h2" mb={2}>{t("titles.base_layer")}</Typography>
                  <BaseLayerSwitcherControl mapId={mapId} isMini={false} isPublic layers={baseLayers} />
            </Box>
            <Divider variant="middle" sx={{ my: 2 }} />
            <Box>
                <PublicLayerTree
                    ready={!!clientLayersCollection}
                    layersCollection={clientLayersCollection}
                    onLayerVisibilityChange={()=>{}}
                />

                <PublicLayerTree
                    ready={!!apiLayersCollection}
                    layersCollection={apiLayersCollection}
                    onLayerVisibilityChange={()=>{}}
                />
            </Box>
        </Box> 
    );

}

export default PublicOptionsPane;